export * from "./list.component";
export * from "./show.component";
export * from "./view.component";
